import React,{ useEffect,useState } from 'react';
import { useNavigate,Link } from "react-router-dom";
import logo from '../image/logo.svg';
import '../styles/home.scss';

function Home() {
  const navigate = useNavigate();
  const [ backgroundvideo, setBackgroundvideo ] = useState(null);
  const { innerWidth: width } = window;
  var yDown = null;

  function scroll(){
    navigate("search");
  }

  function swipeStart(e){
    const firstTouch = e.touches[0];
    yDown = firstTouch.clientY;
  }

  function swipeMove(e){
    if (!yDown ) {
        return;
    }
    var yUp = e.touches[0].clientY;
    var yDiff = yDown - yUp;
    if ( yDiff > 0 ) {
      navigate("search");
    }
    yDown = null;
  }

  function addScrollListener(){
    window.addEventListener('wheel',scroll, { passive: true });
  }


  function addSwipeListener(){
    window.addEventListener('touchstart',swipeStart, { passive: true });
    window.addEventListener('touchmove',swipeMove, { passive: true });
  }

  useEffect(() => {
    var video = null;
    if(width >= 720){
      video = require('../image/background.mp4');
    }else{
      video = require('../image/background_m.mp4');
    }
    setBackgroundvideo(video);
    addScrollListener();
    addSwipeListener();
    return () => {
      window.removeEventListener('wheel',scroll);
      window.removeEventListener('touchstart',swipeStart);
      window.removeEventListener('touchmove',swipeMove);
    }
  }, []);

  return (
    <section id="home">
      {
        backgroundvideo &&
        <video id="backgroundVideo" autoPlay muted loop>
          <source src={backgroundvideo} type="video/mp4" />
        </video>
      }
      <Link to="/search">
          <img id="logo" src={logo} alt="Collar" />
      </Link>
    </section>
  );
}

export default Home;
